import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { saveActivityAction, getActivityValue, deleteActivityAction } from '../../../../modules/activities-management';
import ActivityEdit, { KEY_COPY } from './ActivityEdit';

const getActivity = (list, key) => {
  const activity = { ...getActivityValue(list, key.replace(KEY_COPY, '')) };
  if (key.match(KEY_COPY)) {
    delete activity.label;
  }
  return activity;
};

const mapStateToProps = ({
  admin: { activities: { list } },
}, {
  match: { params: { key } },
}) => ({
  activities: list,
  activity: getActivity(list, key),
  categories: [...new Set(list.reduce((categories, { value: { category } }) =>
    [...categories, category], []))],
});

const mapDispatchToProps = (dispatch, {
  match: { params: { key: keyFromPath } },
}) => ({
  publish: (key, activity) => dispatch(saveActivityAction(key, activity)),
  deleteForm: () => dispatch(deleteActivityAction(keyFromPath)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityEdit));



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/index.js